<template>
  <div>
    <div id="myModal" class="modal" v-if="showModal">
      <!-- Modal content -->
      <div class="modal-content">
        <span
          class="close d-flex align-self-end"
          @click="showModal = false"
        >
          &times;
        </span>

        <div class="d-flex flex-row">
          <div class="col-6 row d-flex flex-column">
            <div class="">
              <div class="tipos-titulo mr-5">
                <span>Destinos Selecionados</span>
              </div>
            </div>

            <div class="">
              <ul>
                <li
                  v-for="i in gruposSelecionados"
                  :key="i.id"
                >
                  {{ i['nome'] }} ({{ i['codigo'] }})
                </li>
              </ul>
            </div>
          </div>

          <div class="col-6 row d-flex flex-column">
            <div class="">
              <div class="tipos-titulo mr-5">
                <span>Tipos Associados</span>
              </div>
            </div>

            <div class="d-flex flex-wrap">
              <div
                v-for="grupo in tiposGrupo"
                :key="grupo.id"
              >
                <div class="">
                  {{ grupo.nome }}
                </div>

                <div class="">
                  <bootstrap-toggle
                    v-model="tipos[grupo.id]"
                    :options="{ on: 'Sim', off: 'Não' }"
                    :disabled="false"
                    :label="grupo.id"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-center button-bar">
            <base-button
              slot="footer"
              type="secondary"
              fill
              @click="showModal = false"
            >
              Cancelar
            </base-button>

            <base-button
              slot="footer"
              type="primary"
              fill
              @click="associarEmLote"
            >
              Salvar em Lote
            </base-button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div
        class="col-8"
        style="border-top: 2px solid #FC7D59; padding-top:2em;"
      >
        <button
          type="secondary"
          @click="showModal = true"
          style="margin-bottom:0px;"
          :disabled="gruposSelecionados.length < 1"
          class="btn btn-import-lote"
        >
          Associação em Lote
        </button>
      </div>

      <div
        class="col-4 d-flex justify-content-end"
        style="border-top: 2px solid #FC7D59; padding-top:2em;"
      >
        <base-button
          slot="footer"
          type="secondary"
          fill
          @click="importar"
        >
          Importar
        </base-button>
      </div>
    </div>

    <template v-if="loading">
      <div class="row">
        <div class="col-12 text-center">
          <div class="d-flex justify-content-center">
            <div class="loader"></div>
          </div>

          <h4 style="margin-top:2em; margin-bottom:2em;">
            Carregando...
          </h4>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="row">
        <div class="col-12">
          <div
            class="table-full-width table-responsive"
            style="overflow-y: hidden; overflow-x: hidden;"
          >
            <table
              id="tbl-guru"
              class="display table"
            >
              <thead>
                <tr>
                  <th></th>

                  <th
                    class="sm"
                    v-for="item in columns"
                    :key="item.field"
                  >
                    <small style="font-weight: bold;">
                      {{ item['label'] }}
                    </small>
                  </th>

                  <th>
                    Ações
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(item, index) in userdata"
                  :key="index"
                >
                  <td>
                    <input
                      type="checkbox"
                      :value="item"
                      v-model="gruposSelecionados"
                    >
                  </td>

                  <td
                    v-for="col in columns"
                    :key="col.field"
                  >
                    <!-- Tipo -->
                    <template v-if="col['field'] == 'tipo'">
                      {{
                        item[col['field']] == 'CANAL'
                          ? 'Canal'
                          : 'Grupo'
                      }}
                    </template>

                    <!-- Ativo -->
                    <template v-else-if="col['field'] == 'ativo'">
                      {{
                        item[col['field']] == 1
                          ? 'Sim'
                          : 'Não'
                      }}
                    </template>

                    <!-- Plataforma -->
                    <template v-else-if="col['field'] == 'plataforma'">
                      {{ getNomePlataforma(item[col['field']]) }}
                    </template>

                    <!-- Instância / Bot -->
                    <template v-else-if="col['field'] == 'destino_envio'">
                      {{ getNomeDestinoEnvio(item) }}
                    </template>

                    <!-- Demais campos -->
                    <template v-else>
                      {{ item[col['field']] }}
                    </template>
                  </td>

                  <td>
                    <base-button
                      icon
                      round
                      class="btn-google"
                      @click="edit(item['id'])"
                    >
                      <i class="tim-icons icon-pencil"></i>
                    </base-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import config from '@/config'
import BootstrapToggle from 'vue-bootstrap-toggle'

export default {
  components: {
    BootstrapToggle
  },

  data() {
    return {
      columns: [
        { label: 'Id', field: 'id' },
        { label: 'Nome', field: 'nome' },
        { label: 'Plataforma', field: 'plataforma' },
        { label: 'Tipo', field: 'tipo' },
        { label: 'Código', field: 'codigo' },
        { label: 'Instância / Bot', field: 'destino_envio' },
        { label: 'Ativo', field: 'ativo' },
      ],

      userdata: {},

      instancias: [],
      telegramBots: [],

      instancia: null,

      grupos: {},

      header: {
        headers: {
          "client-token": "F4d8c61457edb472a8433d9a6570da4bfS"
        }
      },

      loading: true,

      searchOptions: {
        enabled: true,
        placeholder: 'Buscar...',
      },

      gruposSelecionados: [],

      showModal: false,

      tipos: {},

      tiposGrupo: [],
    }
  },

  methods: {
    importar() {
      this.$router.push('grupo/importar')
    },

    hasGroup(grupoId) {
      return Object.keys(this.grupos).includes(grupoId)
    },

    edit(id) {
      this.$router.push('grupo/edit/' + id)
    },

    associarEmLote() {
      let grupos = new Array()

      this.gruposSelecionados.forEach(element => {
        grupos.push(element.id)
      })

      let payload = {
        'grupos': grupos,
        'tipos': this.tipos
      }

      this.$aws
        .post('whatsapp/grupo/lote', payload)
        .then(response => {
          this.grupos = JSON.parse(
            JSON.stringify(response.data)
          )

          this.showModal = false

          this.$swal(
            "Ok!",
            "Destinos salvos com sucesso.",
            "success"
          )
        })
        .catch(error => {
          console.error(error)

          this.showModal = false

          this.$swal(
            "Ops!",
            "Ocorreu um erro ao salvar os destinos.",
            "error"
          )
        })
    },

    check(id) {
      if (this.gruposSelecionados.includes(id)) {
        const index = this.gruposSelecionados.indexOf(id)

        if (index > -1) {
          this.gruposSelecionados.splice(index, 1)
        }
      } else {
        this.gruposSelecionados.push(id)
      }
    },

    getUsuario() {
      try {
        let user = JSON.parse(
          localStorage.ADMIN_AUTH_USER
        )

        return user

      } catch (error) {
        console.error(error)

        localStorage.ADMIN_AUTH_USER = null
      }
    },

    /*
     * Retorna o nome da instância WhatsApp.
     */
    getNomeInstancia(id) {
      let nome = ''

      this.instancias.forEach(element => {
        if (element.id == id) {
          nome = element.nome
        }
      })

      if (nome == '') {
        nome = 'Instância Desconhecida/Inativa'
      }

      return nome
    },

    /*
     * Retorna o nome do bot Telegram.
     */
    getNomeTelegramBot(id) {
      let nome = ''

      this.telegramBots.forEach(element => {
        if (element.id == id) {
          nome = element.nome
        }
      })

      if (nome == '') {
        nome = 'Bot Desconhecido/Inativo'
      }

      return nome
    },

    /*
     * Nome amigável da plataforma.
     *
     * Retrocompatibilidade:
     * se plataforma não vier preenchida,
     * consideramos WhatsApp.
     */
    getNomePlataforma(plataforma) {
      plataforma = (
        plataforma || 'WHATSAPP'
      ).toUpperCase()

      if (plataforma === 'TELEGRAM') {
        return 'Telegram'
      }

      return 'WhatsApp'
    },

    /*
     * Resolve o responsável pelo envio:
     *
     * WhatsApp -> Instância Z-API
     * Telegram -> Bot Telegram
     *
     * Retrocompatibilidade:
     * sem plataforma = WhatsApp.
     */
    getNomeDestinoEnvio(item) {
      const plataforma = (
        item.plataforma || 'WHATSAPP'
      ).toUpperCase()

      if (plataforma === 'TELEGRAM') {
        return this.getNomeTelegramBot(
          item.telegram_bot_id
        )
      }

      return this.getNomeInstancia(
        item.instancia_id
      )
    },
  },

  mounted() {
    /*
     * Tipos de grupo
     */
    this.$aws
      .get('whatsapp/tipogrupo')
      .then(response => {
        if (response.data) {
          this.tiposGrupo = JSON.parse(
            JSON.stringify(response.data)
          )
        }
      })
      .catch(function (error) {
        console.error(error)
      })

    /*
     * Instâncias WhatsApp
     */
    this.$aws
      .get('whatsapp/instancia')
      .then(response => {
        if (response.data) {
          this.instancias = JSON.parse(
            JSON.stringify(response.data)
          )
        }
      })
      .catch(function (error) {
        console.error(error)
      })

    /*
     * Bots Telegram
     */
    this.$aws
      .get('telegram/bot')
      .then(response => {
        if (response.data) {
          this.telegramBots = JSON.parse(
            JSON.stringify(response.data)
          )
        }
      })
      .catch(function (error) {
        console.error(error)
      })

    /*
     * Destinos
     */
    this.$aws
      .get('whatsapp/grupo')
      .then(response => {
        this.userdata = JSON.parse(
          JSON.stringify(response.data)
        )

        /*
         * Retrocompatibilidade.
         *
         * Caso algum registro não possua
         * plataforma, assumimos WHATSAPP.
         */
        if (this.userdata) {
          Object.keys(this.userdata).forEach(key => {
            if (!this.userdata[key].plataforma) {
              this.userdata[key].plataforma = 'WHATSAPP'
            }
          })
        }

        $(document).ready(function () {
          $('#tbl-guru').DataTable({
            select: {
              info: true,
              style: 'multi',
              selector: 'td'
            },

            ordering: false,

            lengthMenu: [
              50,
              100,
              300,
              500
            ],

            searching: true,

            "language": {
              "emptyTable":
                "Nenhum registro disponível na tabela",

              "info":
                "Mostrando _START_ até _END_ de _TOTAL_ registros",

              "infoEmpty":
                "Mostrando 0 até 0 de 0 registros",

              "infoFiltered":
                "(filtrado de um total de _MAX_ registros)",

              "lengthMenu":
                "Mostrar _MENU_ registros",

              "loadingRecords":
                "Carregando...",

              "search":
                "Busca:",

              "zeroRecords":
                "Nenhum registro encontrado.",

              "paginate": {
                "first": "Primeiro",
                "last": "Último",
                "next": "Próximo",
                "previous": "Anterior"
              }
            },
          })
        })

        this.loading = false
      })
      .catch(function (error) {
        console.error(error)
      })
  },
}
</script>

<style lang="scss">
h3 {
  margin: 0px;
}

.dataTables_wrapper {
  margin-top: 20px;

  tbody td:last-child {
    text-align: center;
  }
}

/* HTML: <div class="loader"></div> */
.loader {
  width: 50px;
  aspect-ratio: 1;
  --g: #0000 calc(100% - 5px),
       #FC7D59 calc(100% - 3px) 93%,
       #0000;

  background:
    radial-gradient(farthest-side at bottom, var(--g))
      top / 100% 50%,

    radial-gradient(farthest-side at top, var(--g))
      bottom 18% right 0 / 80% 40%,

    radial-gradient(farthest-side at bottom, var(--g))
      left 50% top 30% / 60% 30%,

    radial-gradient(farthest-side at top, var(--g))
      right 34% bottom 37% / 40% 20%,

    radial-gradient(farthest-side at bottom, var(--g))
      left 52% top 43% / 24% 12%;

  background-repeat: no-repeat;

  animation: l20 1s infinite linear;
}

@keyframes l20 {
  100% {
    transform: rotate(1turn);
  }
}

/* The Modal (background) */
.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;

  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

/* Modal Content/Box */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

/* The Close Button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.tipos-titulo {
  border-bottom: 2px solid #2b3553;
  margin-bottom: 1em;
  margin-top: 2em;
}

.button-bar {
  border-top: 2px solid #FC7D59;
  margin-top: 2em;
  padding-top: 2em;
}
</style>